import styled from 'styled-components';

import media from 'apps/auth/theme/media';
import zIndex from 'apps/auth/theme/zIndex';

export const Container = styled.section`
    background-color: ${(props) => props.theme.white};
    box-shadow:
        0 0 1px rgb(20 20 20 / 12%),
        0 -2px 12px rgb(20 20 20 / 4%);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    z-index: ${zIndex.leftMenuIndex};

    ${media.desktop1224} {
        align-items: center;
        border-right: 1px solid ${(props) => props.theme.grey_28_tr};
        box-shadow: none;
        display: flex;
        right: auto;
        top: 0;
        width: 360px;
    }
`;

export const Menu = styled.ul`
    display: flex;
    justify-content: space-around;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    box-sizing: border-box;

    ${media.tablet720} {
        padding-left: 112px;
        padding-right: 112px;
        max-width: none;
    }

    ${media.desktop1224} {
        display: block;
        padding-left: 40px;
        padding-right: 40px;
        overflow-y: auto;
        max-height: 100%;
    }
`;
